import { useContext } from 'react';

import { ModalWindowContext } from './ModalWindowContext';

export const useModalWindowContext = () => useContext(ModalWindowContext);
